import script from "./LabelEasy.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelEasy.vue?vue&type=script&setup=true&lang=ts"

import "./LabelEasy.vue?vue&type=style&index=0&id=41e4440f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e4440f"]])

export default __exports__